//import { checkTokenExists, setToken } from '../helpers/auth';
import api from './api';
import localforage from "localforage";
import { useCreditStore } from '@/lib/stores/credit'
import { imagePathToBase64 } from '@/helpers/image';

export const SET_COMPANIES_DATA = 'SET_COMPANIES_DATA';
export const UPDATE_COMPANY_DATA = 'UPDATE_COMPANY_DATA';
export const REMOVE_COMPANY = 'REMOVE_COMPANY';

export const fetchCompanies = () => async dispatch => {
  // Fetch companies from API if the user is online else get the companies from indexedDB using localforage
    let newdata;
    if (window.navigator.onLine) {
        return window.axios.get(api.companies.index)
            .then(async (response) => {
                dispatch(setCompaniesData(response.data.companies));

                await localforage.setDriver(localforage.INDEXEDDB);
                await localforage.setItem('bs_companies', response.data.companies);

                newdata = {...response.data};

                return Promise.resolve({ ...response.data });
            })
            .catch(error => {
                return Promise.reject(error)
            });
    } else {
        try {
            await localforage.setDriver(localforage.INDEXEDDB);
            const companies = await localforage.getItem('bs_companies');

            if (companies) {
                newdata = { companies: companies };
                dispatch(setCompaniesData(companies));
            } else {
                const temp = await localforage.getItem('bs_connected_companies');
                newdata = { companies: temp };
                dispatch(setCompaniesData(temp));
            }

            return Promise.resolve(newdata)
        } catch (e) {
            return Promise.reject(e)
        }
    }
};

export const fetchConnectedCompanies = () => async dispatch => {
  let newdata;
  if (window.navigator.onLine) {
      return window.axios.get(api.companies.connected)
          .then(async (response) => {
              dispatch(setCompaniesData(response.data.companies));

              const { retrieveBalance, refreshTimer: { start: startTimer } } = useCreditStore.getState();

              // for each company make a api call to reserve credits
              for (let i = 0; i < response.data.companies.length; i++) {
                let company = response.data.companies[i];
                await retrieveBalance({ companyId: company.id });
              }

              startTimer();

              await localforage.setDriver(localforage.INDEXEDDB);
              await localforage.setItem('bs_connected_companies', response.data.companies);

              // Get the locations for each connected company
                for (let i = 0; i < response.data.companies.length; i++) {
                    let company = response.data.companies[i];
                    let locations = await window.axios.get(api.locations.index.replace(':company', company.id));

                    await localforage.setItem('bs_locations_' + company.id, locations.data.locations);

                    // For each companies location get the sublocations
                    for (let j = 0; j < locations.data.locations.length; j++) {
                        let location = locations.data.locations[j];

                        const localSublocations = await localforage.getItem(`bs_sublocations_${company.id}`);

                        if (!localSublocations) {

                            let sublocations = await window.axios.get(api.sublocations.index.replace(':location', location.id));
                            
                            const mapped = sublocations.data.sublocations.map(async (sublocation) => {
                              if(sublocation?.image_url) {
                                const { base64 } = await imagePathToBase64(sublocation.image_url);
                                sublocation.image_url = base64 ?? null;
                              }
                              return sublocation;
                            })

                            const resolvedSublocations = await Promise.all(mapped);
                            await localforage.setItem('bs_sublocations_' + location.id, resolvedSublocations);
                        }
                    }
                }

                let removals = await window.axios.get(api.removals.index);
                await localforage.setItem('bs_removals', removals.data.removals);

              let questionaires = await window.axios.get(api.questionaires.index);
              await localforage.setItem('bs_questionaires', questionaires.data.questionaires);


              return Promise.resolve({ ...response.data });
          })
          .catch(error => {
              return Promise.reject(error)
          });
  } else {
      try {
          await localforage.setDriver(localforage.INDEXEDDB);
          const companies = await localforage.getItem('bs_connected_companies');

          dispatch(setCompaniesData(companies));
          return Promise.resolve(newdata)
      } catch (e) {
          return Promise.reject(e)
      }
  }
};

export const updateCompany = (company) => dispatch => {
  let data = {status: company.status, '_method': 'PATCH' };
  return window.axios.post(api.companies.update.replace(':company', company.id), data)
        .then((response) => {
          dispatch(updateCompanyData(company));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const deleteCompany = (company) => dispatch => {
  let data = {};
  data['_method'] = 'DELETE';
  return window.axios.post(api.companies.destroy.replace(':company', company.id), data)
        .then((response) => {
          dispatch(removeCompany(company));
          return Promise.resolve({ ...response.data });
        }).catch(error => {
          return Promise.reject(error)
        });
}

export const setCompaniesData = (companies) => ({
  type: SET_COMPANIES_DATA,
  companies
});

export const updateCompanyData = (company) => ({
  type: UPDATE_COMPANY_DATA,
  company
});

export const removeCompany = (company) => ({
  type: REMOVE_COMPANY,
  company
});